class EventBus {
    constructor() {
        this.events = []
    }

    subscribe(eventName, callback) {
        try {
            //console.log("Subscribing to event: ", eventName)

            this.events.push({
                eventName,
                callback
            })
        } catch (e) {
            throw e
        }
    }

    emit(eventName, value) {
        try {
            //console.log("Emitting event: ", eventName, value)
            for (let i = 0; i < this.events.length; i++) {
                if (this.events[i].eventName == eventName) {
                    this.events[i].callback(value)
                }
            }
        } catch (e) {
            throw e
        }
    }
}

const instance = new EventBus();
Object.freeze(instance);

export default instance;